import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IPurchasePoFields, IPurchasePoList, IPurchasePoDetail, IPurchasePoSearch, Detailed, IPurchasePoSettleAndWhConfirm } from "./purchasePoType"
class PurchasePoService {
    async page(searchVo: IPurchasePoSearch) {
        const apiUrl = "/vrm-sa/purchase/findPage";
        return await httpRequest.post<IPurchasePoList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/purchase/findById/${id}`;
        return await httpRequest.get<IPurchasePoDetail>(apiUrl);
    }

    async insert(insertVo: IPurchasePoFields) {
        const apiUrl = "/vrm-sa/purchase/insert";
        return await httpRequest.post<IPurchasePoFields>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchasePoFields) {
        const apiUrl = "/vrm-sa/purchase/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }

    // 库房确认
    async warehousing(params: IPurchasePoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/purchase/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm-sa/purchase/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IPurchasePoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/purchase/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //采购单作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/purchase/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导入明细
    async import(file: { file: File }) {
        const apiUrl = "/vrm-sa/purchase/details/import";
        return await httpRequest.post<boolean>(apiUrl, file);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/vrm-sa/purchase/detail/downloadTpl";
        return await httpRequest.getFile(apiUrl);
    }
    //采购单批量导出
    async export(params: IPurchasePoSearch) {
        const apiUrl = "/vrm-sa/purchase/export";
        return await httpRequest.postFile(apiUrl, params,{ timeout: 600000 });
    }
    //采购单详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/purchase/detailsExport";
        return await httpRequest.postFile(apiUrl, params,{ timeout: 600000 });
    }
}

export const purchasePoService = new PurchasePoService();